export default {
  title: 'Modificatori',
  master_title: 'Mod brand - Modificatori',
  products_creation_disabled:
    'Din cauza integrării active cu {{integration}}, crearea de produse noi nu este permisă. Dacă trebuie să modificați meniul, faceți modificările în {{integration}} și sincronizați meniul.',
  labels: {
    select_all: 'Selectați toate',
  },
  buttons: {
    add_modifier: 'Adăugare modificator',
    delete_selected: 'Ștergere selecție',
    refresh: 'Reîmprospătare',
  },
  toasts: {
    failed_to_load_data: 'Încărcarea datelor a eșuat',
  },
};
